import { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Code,
  Container,
  Group,
  NumberFormatter,
  Table,
  Title,
  Text,
} from "@mantine/core";
import { Link, useLocation } from "wouter";
import { IconPlus } from "@tabler/icons-react";
import { getSignupCodes } from "../api";
import Timeago from "../../../Boilerplate/_Shared/Timeago";
import ListPending from "../_Shared/ListPending";

function StatusBadge({ code }) {
  if (!code.isActive) return <Badge color="gray">Inactive</Badge>;
  if (code.expiresAt && new Date(code.expiresAt) < new Date())
    return <Badge color="red">Expired</Badge>;
  if (code.maxRedemptions > 0 && code.redemptionCount >= code.maxRedemptions)
    return <Badge color="blue">Fully Redeemed</Badge>;
  return <Badge color="teal">Active</Badge>;
}

export default function SignupCodeList() {
  const [codes, setCodes] = useState(null);
  const [, setLocation] = useLocation();

  useEffect(() => {
    getSignupCodes()
      .then((data) => setCodes(Array.isArray(data) ? data : []))
      .catch(() => setCodes([]));
  }, []);

  return (
    <Container size="xl">
      <Group justify="space-between" align="center">
        <Title order={1}>Signup Codes</Title>
        <Button
          leftSection={<IconPlus size={16} />}
          variant="default"
          component={Link}
          to="/admin/signup-codes/create"
        >
          Create Code
        </Button>
      </Group>

      <ListPending
        items={codes}
        emptyText="No signup codes yet. Create one to get started."
      >
        {(rows) => (
      <Table
        mt="lg"
        highlightOnHover
        style={{ cursor: "pointer" }}
        striped
      >
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Code</Table.Th>
            <Table.Th>Description</Table.Th>
            <Table.Th>Status</Table.Th>
            <Table.Th ta="right">Credits</Table.Th>
            <Table.Th ta="right">SKUs</Table.Th>
            <Table.Th ta="right">Redeemed</Table.Th>
            <Table.Th>Created</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {rows.map((code) => (
            <Table.Tr
              key={code.id}
              onClick={() => setLocation(`/admin/signup-codes/${code.id}`)}
            >
              <Table.Td>
                <Code fw={600}>{code.code}</Code>
              </Table.Td>
              <Table.Td>
                <Text size="sm" c="dimmed" lineClamp={1}>
                  {code.description || "-"}
                </Text>
              </Table.Td>
              <Table.Td>
                <StatusBadge code={code} />
              </Table.Td>
              <Table.Td ta="right">
                <NumberFormatter
                  value={code.creditsToGrant}
                  thousandSeparator
                />
              </Table.Td>
              <Table.Td ta="right">
                <NumberFormatter
                  value={code.creditsToGrant / 100}
                  thousandSeparator
                />
              </Table.Td>
              <Table.Td ta="right">
                {code.redemptionCount}
                {code.maxRedemptions > 0 && (
                  <Text span c="dimmed" size="sm">
                    /{code.maxRedemptions}
                  </Text>
                )}
              </Table.Td>
              <Table.Td>
                <Timeago date={code.idCreated} />
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
        )}
      </ListPending>
    </Container>
  );
}
